
/**
 *
 *
 * @class Oskari.nba.bundle.nba-registers.view.RegisterSearchTab
 */
Oskari.clazz.define('Oskari.nba.bundle.nba-registers.view.RegistersSearchTab',
    /**
     *
     *
     */
    function (instance) {
        this.instance = instance;
        this.sandbox = instance.getSandbox();
        this.loc = instance.getLocalization('tab');
        this.resultsGrid = null;
        this.resultsContainer = null;
        this.templates = {};
        for (var t in this._templates) {
            if (this._templates.hasOwnProperty(t)) {
                this.templates[t] = jQuery(this._templates[t]);
            }
        }
        this.progressSpinner = Oskari.clazz.create('Oskari.userinterface.component.ProgressSpinner');
        this.tabContent = this._initContent();
        //this.resultsContainer = this._initResultGrid();
        this._getRegisters(),
        this._dialog = null;
    }, {
        _templates: {
            tabContent: '<div class="nba-searchContainer">'
                + '<div class="nbaRegisterHeader"></div>'
                + '<div class="registerSelect"><select></select></div>'
                + '<div class="limitResultsToArea"><input id="limitResultsToAreaCheckbox" type="checkbox"></input></div>'
                + '<div class="searchDescription"></div>'
                + '<div class="nba-searchInput"></div>'
                + '<div class="nba-searchButton"></div>'
                + '<div class="showAllResultsLink"></div>'
                + '<div class="nba-progressSpinner"></div>'
                + '</div>',
            resultsGrid: '<div class="resultsContainer">'
                + '<div class="resultsTitle"></div>'
                + '<div class="grid"></div>'
                + '<div>'
        },

        getTitle: function () {
            return this.loc.title;
        },

        getContent: function () {
            return this.tabContent;
        },

        requestToAddTab: function () {
            var requestBuilder = this.sandbox.getRequestBuilder('Search.AddTabRequest'),
                request;

            if (requestBuilder) {
                request = requestBuilder(this.getTitle(), this.getContent());
                this.sandbox.request(this.instance, request);
            }
        },

        _showMessage: function(title, content, buttons, isModal) {
            var me = this;
            this.closeDialog();
            this._dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
            if(typeof buttons === 'undefined') {
                var okBtn = Oskari.clazz.create('Oskari.userinterface.component.buttons.OkButton');

                okBtn.setHandler(function () {
                    me._dialog.close(true);
                    me._dialog = null;
                });
                buttons = [okBtn];
            }
            this._dialog.show(title, content, buttons);
            if (isModal) {
                this._dialog.makeModal();
            }
        },

        closeDialog : function() {
            if(this._dialog) {
                this._dialog.close(true);
                this._dialog = null;
            }
        },

        _initContent: function () {
            var me = this,
                tabContent = this.templates.tabContent.clone(),
                headerLabel = this.loc['header'],
                selectLabel = this.loc['selectRegister'],
                checkboxLabel = this.loc['limitToArea'],
                searchDesc = this.loc['searchDesc'],
                searchPlaceholder = this.loc['searchPlaceholder'],
                searchInput = Oskari.clazz.create('Oskari.userinterface.component.FormInput', 'nba-registers-search-input'),
                searchButton = Oskari.clazz.create('Oskari.userinterface.component.buttons.SearchButton'),
                showAllResultsLink = jQuery('<a href="#">' + this.loc['showAllResultsOnMap'] + '</a>');

            tabContent.find('div.nbaRegisterHeader').append(headerLabel);
            tabContent.find('div.registerSelect').prepend(selectLabel);
            tabContent.find('div.limitResultsToArea').append(checkboxLabel);
            //tabContent.find('div.searchDescription').append(searchDesc);

            var doSearch = function () {
                var selectElement = me.getContent().find('div.registerSelect select'),
                    checkboxElement =  tabContent.find('#limitResultsToAreaCheckbox');
                //clear data in grid
                //var dataModel = me.resultsGrid.getDataModel().setData([]);
                if (me.resultsContainer != null) {
                    me.resultsContainer.empty();
                }
                tabContent.find('div.showAllResultsLink').hide();

                //If user has selected a filter with geometry the name/ID should not be mandatory parameter in the search
                if (checkboxElement.prop('checked')) {
                    searchInput.setRequired(false);
                } else {
                    searchInput.setRequired(true, "You should fill this input"); //TODO make localization
                }

                searchInput.clearErrors();
                var errors = searchInput.validate();
                if (errors != null && errors.length > 0) {
                    searchInput.showErrors(errors);
                } else {

                    var params = {
                        keyword: searchInput.getValue(),
                        registries: selectElement.val(),
                        geometry: ""
                    };

                    if (checkboxElement.prop('checked')) {
                        //determine selected geometries on the map
                        var selectedLayers = me.sandbox.findAllSelectedMapLayers(),
                            geometryFilters = [],
                            layerFeatures,
                            layer,
                            feature;

                        var wfsService = me.sandbox.getService('Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService');
                        var vectorFeatureService = me.sandbox.getService('Oskari.mapframework.service.VectorFeatureService');
                        var wfsSelections = wfsService.getWFSSelections();
                        var geoJson;
                        console.log(wfsSelections);

                        /*for (var i = 0; i < selectedLayers.length; i++) {
                            var layer = selectedLayers[i];
                            if (layer.getClickedGeometries !== null && layer.getClickedGeometries !== undefined && layer.getClickedGeometries().length > 0) {
                                for (var j = 0; j < layer.getClickedGeometries().length; j++) {
                                    geometryFilters.push(layer.getClickedGeometries()[j][1]);
                                }
                            }
                        }*/
                        if(wfsSelections.length > 0) {
                            for(var i = 0; i < wfsSelections.length; i++) {
                                if(wfsSelections[i].layerId !== null && wfsSelections[i].featureIds.length > 0) {
                                    layerFeatures = me.sandbox.findRegisteredModuleInstance('MainMapModule').getLayerPlugins('wfs').getOLMapLayers(me.sandbox.findMapLayerFromAllAvailable(wfsSelections[i].layerId))[0].getSource().getFeatures();
                                    layer = me.sandbox.findMapLayerFromAllAvailable(wfsSelections[i].layerId);
                                    for(var j = 0; j < wfsSelections[i].featureIds.length; j++) {
                                        var geometryString;
                                        feature = layerFeatures.filter(f => {return f.id_ === wfsSelections[i].featureIds[j]})[0];
                                        geoJson = vectorFeatureService._getGeojson(feature);
                                        console.log(geoJson);
                                        if(geoJson.features[0].geometry.type !== "MultiPoint") {
                                            //geometryString = geoJson.features[0].geometry.coordinates[0][0].join();
                                            geometryString = handleGeometryLists(geoJson.features[0].geometry.coordinates[0][0]);
                                            var filterString = geoJson.features[0].geometry.type +" (((" + geometryString + ")))";
                                            console.log(geometryString);
                                            console.log(filterString);
                                            geometryFilters.push(filterString);
                                        }
                                    }

                                }
                            }
                        }
                        params.geometry = geometryFilters.join('|');
                        console.log(geometryFilters);
                        //check amount of selected geometries and show warning if needed
                        if (geometryFilters.length > 10) {
                            var continueButton = Oskari.clazz.create('Oskari.userinterface.component.Button'),
                                cancelButton = Oskari.clazz.create('Oskari.userinterface.component.buttons.CancelButton'),
                                buttons = [cancelButton, continueButton];

                            cancelButton.setHandler(function() {
                                me._dialog.close(true);
                                me._dialog = null;
                            });

                            continueButton.setTitle(me.loc.continue);
                            continueButton.addClass('primary');
                            continueButton.setHandler(function() {
                                me._dialog.close(true);
                                me._dialog = null;
                                me._getRegistryItems(params);
                            });
                            me._showMessage(me.loc.warningTitle, me.loc.warningTooManyAreas, buttons);
                        } else {
                            me._getRegistryItems(params);
                        }
                    } else {
                        me._getRegistryItems(params);
                    }
                }
            }
            function handleGeometryLists (list) {
                var geometryList = [],
                    geometryString;

                if(list.length > 0) {
                    for(var i = 0; i < list.length; i++) {
                        var listNode = list[i].join(" ");
                        console.log(listNode);
                        geometryList.push(listNode);
                    }
                }
                geometryString = geometryList.join(", ");
                return geometryString;
            }
            //add search input
            searchInput.setIds(null, "nba-registers-search-input");
            searchInput.setPlaceholder(searchPlaceholder);
            searchInput.addClearButton();
            searchInput.bindEnterKey(doSearch);

            //add search button
            searchButton.setHandler(doSearch);

            tabContent.find('div.nba-searchInput').append(searchInput.getField());
            tabContent.find('div.nba-searchButton').append(searchButton.getElement());


            showAllResultsLink.bind('click', function () {
                me._showAllResultsOnMap();
                return false;
            });
            tabContent.find('div.showAllResultsLink').append(showAllResultsLink);
            tabContent.find('div.showAllResultsLink').hide();
            this.progressSpinner.insertTo(tabContent.find('div.nba-progressSpinner'));

            return tabContent;
        },

        _renderResultGrid: function (results) {
            var me = this,
                resultGrid = this.templates.resultsGrid.clone(),
                gridTexts = this.loc['grid'],
                gridModel = Oskari.clazz.create('Oskari.userinterface.component.GridModel'),
                grid = Oskari.clazz.create('Oskari.userinterface.component.Grid'),
                searchInput = jQuery(me.tabContent.find('#nba-registers-search-input')),
                editorRoles = me.instance.conf.editorRoles,
                dataSourceName,
                registriesConf = me.instance.conf != null ? me.instance.conf.registries : {},
                lang = Oskari.getLang(),
                currentLocale;

            //set the title and number of given results
            resultGrid.find('div.resultsTitle').append(me.loc.searchResults + ": " + results.length + " " + me.loc.forSearch + " '" + searchInput.val() + "'");

            gridModel.setIdField('id');
            console.log(results);
            _.each(results, function (result) {
                if (registriesConf[result.registryIdentifier] != null && registriesConf[result.registryIdentifier][lang] != null) {
                    //Try set item class name as data source. If translation is not available then get general name of registry.
                    currentLocale = registriesConf[result.registryIdentifier][lang];
                    dataSourceName = currentLocale[result.itemClassName]

                    if (dataSourceName == null || dataSourceName == '') {
                        dataSourceName = currentLocale.name;
                    }
                } else {
                    dataSourceName = result.registryIdentifier;
                }

                gridModel.addData({
                    'id': result.id,
                    'desc': result.desc != null ? result.desc.trim() : '',
                    'nbaUrl': result.nbaUrl,
                    'mapLayers': result.mapLayers,
                    'bounds': result.bounds,
                    'itemClassName': result.itemClassName,
                    'registryIdentifier': result.registryIdentifier,
                    'registry': dataSourceName,
                    'municipality': result.municipality,
                    'editable': result.editable,
                    'markersCoordinates': result.markersCoordinates
                });
            });

            grid.setDataModel(gridModel);
            grid.setVisibleFields(['id', 'desc', 'registry', 'municipality']);

            grid.setColumnValueRenderer('id', function (name, data) {
                if(typeof data === 'undefined') {
                    return name;
                }

                var idColumnDiv = jQuery('<div></div>'),
                    registryEditRoles = editorRoles[data.registryIdentifier] != null ? editorRoles[data.registryIdentifier] : editorRoles['general'];

                if (me._hasUserPermissions(registryEditRoles) && data.editable === true) {
                    var editLink = jQuery('<a href="#" class="nba-edit-link" />');
                    editLink.bind('click', function () {
                        //zoom to object
                        me._zoomToObject(data, false);

                        //open registry editor
                        me.sandbox.postRequestByName('RegistryEditor.ShowRegistryEditorRequest', [data]);
                        //close Search bundle after moving to registry editor
                        me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [undefined, 'close', 'Search']);

                        return false;
                    });
                    //return editLink;
                    idColumnDiv.append(editLink);
                }
                var idLink = jQuery('<a href="#">' + name + '</a>');
                idLink.bind('click', function () {
                    //zoom to object and show GFI popup
                    me._zoomToObject(data, true);
                    return false;
                });
                idColumnDiv.append(idLink);
                return idColumnDiv;
            });

            grid.setColumnUIName('id', gridTexts.id);
            grid.setColumnUIName('desc', gridTexts.desc);
            grid.setColumnUIName('registry', gridTexts.registry);
            grid.setColumnUIName('municipality', gridTexts.municipality);
            grid.renderTo(resultGrid.find('div.grid'));

            this.tabContent.append(resultGrid);
            this.resultsGrid = grid;
            return resultGrid;
        },

        _zoomToObject: function (data, showGfi) {
            var me = this

            //remove all markers
            var removeMarkersReqBuilder = me.sandbox.getRequestBuilder('MapModulePlugin.RemoveMarkersRequest');
            if (removeMarkersReqBuilder) {
                me.sandbox.request(me.instance, removeMarkersReqBuilder());
            }

            //showing all layers for the register
            if (data != null && data.mapLayers != null) {
                for (var i = 0; i < data.mapLayers.length; i++) {
                    var mapLayerId = data.mapLayers[i].mapLayerID,
                        layer = me.sandbox.findMapLayerFromAllAvailable(mapLayerId);
                    if (layer != null) {
                        me.sandbox.postRequestByName('AddMapLayerRequest', [mapLayerId, true]);
                    }
                }
            }

            if (data != null && data.bounds != null) {
                var map = Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule').getMap();
                console.log(data.bounds);
                var extent = data.bounds;
                var lon = (extent[2] + extent[0])/2;
                var lat = (extent[3] + extent[1])/2;
                var lonlat = {lon: lon, lat: lat};

                //show new marker(s)
                var geoJson = {
                    'type': 'FeatureCollection',
                    'crs': {
                        'type': 'name',
                        'properties': {
                            'name': 'EPSG:3067'
                        }
                    },
                    'features': []};
                    if(data.markersCoordinates) {
                        for (var j = 0; j < data.markersCoordinates.length; j++) {
                            lon = data.markersCoordinates[j].coordinateX
                            lat = data.markersCoordinates[j].coordinateY
                            var marker = {
                                'type': 'Feature',
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [lon, lat]
                                }
                            }
                            geoJson.features.push(marker);
                        }
                    }
                    else{
                        var marker = {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Point',
                                'coordinates': [lon, lat]
                            }
                        }
                        geoJson.features.push(marker);
                    };

                var rn = 'MapModulePlugin.AddFeaturesToMapRequest';
                var options = {
                    layerId: 'MARKER_LAYER',
                    clearPrevious: true,
                    centerTo: true,
                    "featureStyle": {
                        "image": {
                            "shape": 4,
                            "size": 5,
                        }
                    },
                };
                if(!showGfi){
                    me.sandbox.postRequestByName(rn, [geoJson, options]);
                }
                //show GFI popup
                if (showGfi) {
                    var popupData = me._getGfiPopupData(data);
                    var registryData = {
                        "via": "registry",
                        "features": [popupData],
                        "lonlat": lonlat
                    };
                    this._handleNbaInfoResult(registryData);
                    var infoEvent = me.sandbox.getEventBuilder('GetInfoResultEvent')(registryData);
                    me.sandbox.notifyAll(infoEvent);
                    me.sandbox.postRequestByName(rn, [geoJson, options]);
                }
            } else {
                me._showMessage(me.loc.noticeTitle, me.loc.searchResultNoGeometry);

                if (data != null && showGfi) {
                    var popupData = me._getGfiPopupData(data);
                    var registryData = {
                        "via": "registry",
                        "features": [popupData],
                        "lonlat": Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule').getMapCenter()
                    };
                    //this._handleNbaInfoResult(registryData);
                    var infoEvent = me.sandbox.getEventBuilder('GetInfoResultEvent')(registryData);
                    me.sandbox.notifyAll(infoEvent);
                }
            }
        },

        /**
         * Formats the given data and sends a request to show infobox.
         *
         * @method _handleInfoResult
         * @private
         * @param  {Object} data
         */
        _handleNbaInfoResult: function (data) {
            var me = this,
                content = [],
                contentData = {},
                fragments = [],
                colourScheme,
                font,
                actions = {},
                editorRoles = Oskari.getSandbox().findRegisteredModuleInstance('nba-registers').conf.editorRoles,
                loc = Oskari.getLocalization("nba-registers").gfiPopup,
                wideHeader = false;

             if(data.via === 'registry') {
                fragments = this.formatters.registry(data, this);
                wideHeader = true;
                if (data.features != null && fragments.length) {
                    for (var i = 0; i < data.features.length; i++) {
                        //if user has permissions add edit action for the registry item
                        var registryEditRoles = editorRoles[data.features[i].registryIdentifier] != null ? editorRoles[data.features[i].registryIdentifier] : editorRoles['general'];
                        if (this._hasUserPermissions(registryEditRoles) && data.features[i].editable === true) {
                            var itemData = {
                                id: data.features[i].id,
                                registryIdentifier: data.features[i].registryIdentifier,
                                mapLayers: data.features[i].mapLayers
                            };
                            actions = [];
                            actions.push({name: loc.editItem + ' ' + itemData.id,
                                type: 'link',
                                action: function () {
                                    //showing all layers for the register
                                    if (itemData != null && itemData.mapLayers != null) {
                                        for (var j = 0; j < itemData.mapLayers.length; j++) {
                                            var mapLayerId = itemData.mapLayers[j].mapLayerID,
                                                layer = Oskari.getSandbox().findMapLayerFromAllAvailable(mapLayerId);
                                            if (layer != null) {
                                                Oskari.getSandbox().postRequestByName('AddMapLayerRequest', [mapLayerId, true]);
                                            }
                                        }
                                    }
                                    //open registry editor
                                    Oskari.getSandbox().postRequestByName('RegistryEditor.ShowRegistryEditorRequest', [itemData]);
                                    //close Search bundle after moving to registry editor
                                    Oskari.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [undefined, 'close', 'Search']);
                                    me._closeGfiInfo();
                                }});
                        }
                    }
                }

            } else {
                fragments = this._formatWFSFeaturesForInfoBox(data);
            }

            if (fragments.length) {
                contentData.actions = actions;
                contentData.html = this._renderFragments(fragments, wideHeader);
                contentData.layerId = fragments[0].layerId;
                content.push(contentData);
            }

            if (_.isObject(this._config)) {
                colourScheme = this._config.colourScheme;
                font = this._config.font;
            }
        },

        /**
         * Closes the infobox with GFI data
         *
         * @method _closeGfiInfo
         * @private
         */
        _closeGfiInfo: function () {
            var reqBuilder = this.getSandbox().getRequestBuilder(
                'InfoBox.HideInfoBoxRequest'
                ),
                request;

            if (reqBuilder) {
                request = reqBuilder(this.infoboxId);
                Oskari.getSandbox().request(this, request);
            }
        },

        /**
         * @method _hasUserPermissions
         * Checks if any of the user's roles is contained in allowedRoles array
         *
         * @param {Array} allowedRoles array of role names
         *
         */
        _hasUserPermissions: function (allowedRoles) {
            var me = this,
                userRoles = me.sandbox.getUser().getRoles(),
                hasPermissions = false;

            if (me.sandbox.getUser().isLoggedIn()) {
                for (var i = 0; i < userRoles.length; i++) {
                    if(allowedRoles.some(allowedRole=> allowedRole === userRoles[i].name)){
                        hasPermissions = true;
                        break;
                    }
                }
            }
            return hasPermissions;
        },

        /**
         * Shows given content in given location using infobox bundle
         *
         * @method _showNbaGfiInfo
         * @private
         * @param {Object[]} content infobox content array
         * @param {data} data.lonlat location for the GFI data
         * @param {formatters} formatter functions
         * @param {params} params for request
         */
        _showNbaGfiInfo: function (content, data, formatters, params) {
            var reqBuilder = Oskari.getSandbox().getRequestBuilder(
                'InfoBox.ShowInfoBoxRequest'
                ),
                request;
            var options = {
                hidePrevious: params.hidePrevious === undefined ? true : params.hidePrevious,
                colourScheme: params.colourScheme,
                font: params.font
            };

            if (reqBuilder) {
                request = reqBuilder(
                    params.infoboxId,
                    params.title,
                    content,
                    data.lonlat,
                    options
                );
                Oskari.getSandbox().request("nba-registers", request);
            }
        },

        /**
         * @method _getRegisters
         * Get register names from config of the bundle
         */
        _getRegisters: function () {
            var me = this,
                conf = me.instance.conf,
                registries = [],
                lang = Oskari.getLang(),
                selectElement = this.getContent().find('div.registerSelect select'),
                registryName,
                i;

            if (conf != null) {
                registries = conf.registries;
                //add 'all' element
                var allOptionElement = document.createElement("option");
                allOptionElement.setAttribute("value", "");
                var text = document.createTextNode(me.loc.all);
                allOptionElement.appendChild(text);
                selectElement.append(allOptionElement);

                for (i in registries) {
                    if (registries[i][lang] != null) {
                        registryName = registries[i][lang].name;
                    } else {
                        registryName = i;
                    }
                    var optionElement = document.createElement("option");
                    optionElement.setAttribute("value", i);
                    var text = document.createTextNode(registryName);
                    optionElement.appendChild(text);
                    selectElement.append(optionElement);
                }
            }
        },

        _getRegistryItems: function (params) {
            var me = this;
            this.progressSpinner.start();
            this.instance.getSearchService().getRegistryItems(
                params,
                function (results) {
                    me._handleRegistryItemsResults(results);
                    console.log(results);
                },
                function (jqXHR, textStatus, errorThrown) {
                    me.progressSpinner.stop();

                    if (textStatus == 'Gateway Time-out') {
                        me._showMessage(me.loc.errorTitle, me.loc.searchErrorTimeout);
                    } else {
                        me._showMessage(me.loc.errorTitle, me.loc.searchErrorGeneral);
                    }
                });
        },

        _handleRegistryItemsResults: function (results) {
            this.progressSpinner.stop();
            if (jQuery.isEmptyObject(results)) {
                this.tabContent.find('div.showAllResultsLink').hide();
            } else {
                this.tabContent.find('div.showAllResultsLink').show();
            }
            console.log(results);
            this.resultsContainer = this._renderResultGrid(results);
        },

        _showAllResultsOnMap: function () {
            var me = this,
                mapModule = me.sandbox.findRegisteredModuleInstance('MainMapModule'),
                geoJson = {
                    'type': 'FeatureCollection',
                    'crs': {
                        'type': 'name',
                        'properties': {
                            'name': 'EPSG:3067'
                        }
                    },
                    'features': []};
            //1. get result items
            if (me.resultsGrid != null) {
                var items = me.resultsGrid.getDataModel().getData();

                for (var i = 0; i < items.length; i++) {
                    var lon = null,
                        lat = null;
                    var data = items[i];
                    if(data.markersCoordinates) {
                        for (var j = 0; j < data.markersCoordinates.length; j++) {
                            lon = data.markersCoordinates[j].coordinateX
                            lat = data.markersCoordinates[j].coordinateY
                            var marker = {
                                'type': 'Feature',
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [lon, lat]
                                }
                            }
                            geoJson.features.push(marker);
                        }
                    }
                    else if (data.bounds){
                        var extent = data.bounds;
                        lon = (extent[2] + extent[0])/2;
                        lat = (extent[3] + extent[1])/2;
                        var marker = {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Point',
                                'coordinates': [lon, lat]
                            }
                        }
                        geoJson.features.push(marker);
                    };
                }

                var rn = 'MapModulePlugin.AddFeaturesToMapRequest';
                var options = {
                    layerId: 'MARKER_LAYER',
                    clearPrevious: true,
                    centerTo: true,
                    "featureStyle": {
                        "image": {
                            "shape": 4,
                            "size": 5,
                        }},};
                Oskari.getSandbox().postRequestByName(rn, [geoJson, options]);
                }
            },
        /**
         * @method _getGfiPopupData
         * Filters grid model data passed to the popup
         *
         * @param {Object} data grid model data
         *
         */
        _getGfiPopupData: function (data) {
            return {
                'id': data.id,
                'desc': data.desc,
                'nbaUrl': data.nbaUrl,
                'mapLayers': data.mapLayers,
                'bounds': data.bounds,
                'itemClassName': data.itemClassName,
                'registryIdentifier': data.registryIdentifier,
                'registry': data.registry,
                'municipality': data.municipality,
                'editable': data.editable
            }
        },
    });
